import { createApiSlice } from 'app/createApiSlice'
import { API_CONFIGURATIONS, API_REPORT_PNBP } from 'utils/apiList'

export const reportPnbpListApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'reportPnbpList/api',
  endpoints(builder) {
    return {
      fetchConfiguration: builder.query({
        query() {
          return {
            url: API_CONFIGURATIONS,
          }
        },
      }),
      fetchReports: builder.query({
        query() {
          return {
            url: API_REPORT_PNBP,
          }
        },
      }),
      addReport: builder.mutation({
        query(payload) {
          return {
            url: API_REPORT_PNBP,
            method: 'POST',
            body: payload,
          }
        },
      }),
      fetchLedger: builder.query({
        query({ startdate, enddate, filter, page, size }) {
          return {
            url: '/api/v2/bussines/cashflow',
            params: {
              size,
              startdate,
              page,
              enddate,
              subtype: filter,
              sortby: 'ts',
              sortdir: 'desc',
              filterpnbp: 1,
            },
          }
        },
      }),
    }
  },
})

export const {
  useFetchConfigurationQuery,
  useFetchReportsQuery,
  useLazyFetchReportsQuery,
  useAddReportMutation,
  useFetchLedgerQuery,
  useLazyFetchLedgerQuery,
} = reportPnbpListApiSlice
